import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 11,
	viewBox: "0 0 22 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11 11L0 0H22L11 11Z",
		fill: "#5F5F5F"
	})
});
export default SvgArrowDownIcon;
